import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, } from 'recharts';
import Spinner from '../Spinner/spinner';
import { ToastContainer } from 'react-toastify';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import UseDashboard from './Hooks/useDashboard';

const Dashboard = () => {
  const {
    handleChange,
    countryCheck,
    spinner,
    currentCountry,
    revenueEarn,
    revenueEarnPhonepe,
    provider,
    totalServiceProviderMonthly,
    totalFreePlan,
    totalPaidPlan,
    totalRevenueMonthlyStripe,
    totalRevenueMonthlyPhonepe,
    conversionRateChartData,
    filter,
    countryData,
    chartData,
  } = UseDashboard()

  return (
    <>
      <ToastContainer />
      <section style={{ background: "#F8FAFB", }}>
        <div className="cus-padd" >
          {spinner ? <Spinner /> : null}
          <div className="d-flex justify-content-between">
            <header>
              <h2 className='page-tittle'>
                Dashboard
              </h2>
            </header>
          </div>
          <hr />

          <div className="container-fluid">
            <div className="row">

              <div className="col-sm-6"></div>
              <div className='mt-4 d-flex justify-content-between'>
                <h5 className='fw-bold'>
                  Overview
                </h5>
                {/* <Button variant="text" sx={{ color: 'black', fontSize: '12px', background: 'white' }} startIcon={<FilterListIcon />}>Filters</Button> */}
              </div>
              <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='green' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <h5 className='fw-bold ms-2 green'>{totalServiceProviderMonthly?.growthPercentage}%</h5>
                </div>
                <p className=''>No. of New Subscribers</p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>{totalServiceProviderMonthly?.thisMonths}</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>{totalServiceProviderMonthly?.lastMonths}</h5>
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='green' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <h5 className='fw-bold ms-2 green'>{totalFreePlan?.growthPercentage}%</h5>
                </div>
                <p>No. of Active Users (Free)</p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>{totalFreePlan?.thisMonths}</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>{totalFreePlan?.lastMonths}</h5> 
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div>
              {/* <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='red' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 5v14M5 12l7 7 7-7" />
                  </svg>
                  <h5 className='fw-bold ms-2 red'>65.2%</h5>
                </div>
                <p>No of Active Users (Shifted to Plan)</p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>1200</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>1000</h5>
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div> */}
              <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='green' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <h5 className='fw-bold ms-2 green'>{totalPaidPlan?.growthPercentage}%</h5>
                </div>
                <p>No. of Active Users (Paid) </p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>{totalPaidPlan?.thisMonths}</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>{totalPaidPlan?.lastMonths}</h5>
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div>
              {/* <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='red' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 5v14M5 12l7 7 7-7" />
                  </svg>
                  <h5 className='fw-bold  ms-2 red'>40%</h5>
                </div>
                <p>No. of Active Users (Users Left)</p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>1200</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>1000</h5>
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div> */}
              <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='green' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <h5 className='fw-bold  ms-2 green'>{totalRevenueMonthlyStripe?.growthPercentage}%</h5>
                </div>
                <p>Total Revenue Earned Stripe</p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>{totalRevenueMonthlyStripe?.thisMonths}</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>{totalRevenueMonthlyStripe?.lastMonths}</h5>
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 overview-card mt-4  text-center">
                <div className='d-flex  justify-content-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" className='green' viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <h5 className='fw-bold ms-2 green'>{totalRevenueMonthlyPhonepe?.growthPercentage}%</h5>
                </div>
                <p>Total Revenue Earned Razorpay</p>
                <div className='d-flex justify-content-evenly'>
                  <div>
                    <h5 className='fw-bold m-0'>{totalRevenueMonthlyPhonepe?.thisMonths}</h5>
                    <p className='_text'>Current Month</p>
                  </div>
                  <div className='vl'></div>
                  <div>
                    <h5 className='fw-bold m-0'>{totalRevenueMonthlyPhonepe?.lastMonths}</h5>
                    <p className='_text'>Last Month</p>
                  </div>
                </div>
              </div>
              <hr className='mt-5' />
              <div className='col-sm-12 d-flex justify-content-end mt-4'>
                <div style={{ width: '15%' }}>
                  <select className='form-select' name="country" value={filter.country} onChange={(e) => { handleChange(e); countryCheck(e.target.value) }}>
                    <option hidden>Select Country</option>
                    <option value='ALL'>All</option>
                    {countryData?.map((item, index) =>
                      <option value={item._id} key={index}>{item.name}</option>
                    )}
                  </select>
                </div>
              </div>

              {
                currentCountry == 'India' ? null
                  :
                  <>

                    <h5 className='fw-bold mt-2'>
                      Stripe Payment
                    </h5>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <MonetizationOnIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{revenueEarn?.netRevenue ? revenueEarn?.netRevenue : 0}</h5>
                        <p>Total Revenue Earned</p>
                      </div>
                      <div></div>
                    </div>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <MonetizationOnIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{revenueEarn?.totalPaidRevenue ? revenueEarn?.totalPaidRevenue : 0}</h5>
                        <p>Received Payment</p>
                      </div>
                      <div></div>
                    </div>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <MonetizationOnIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{revenueEarn?.totalRefundRevenue ? revenueEarn?.totalRefundRevenue : 0}</h5>
                        <p>Refund</p>
                      </div>
                      <div></div>
                    </div>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <PeopleAltIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{provider ? provider : 0}</h5>
                        <p>Total Providers</p>
                      </div>
                      <div></div>
                    </div>
                  </>
              }
              {
                currentCountry == 'India' || filter.country == 'ALL' ?
                  <>
                    <h5 className='fw-bold mt-4'>
                    Razorpay  Payment
                    </h5>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <CurrencyRupeeIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{revenueEarnPhonepe?.netRevenue ? revenueEarnPhonepe?.netRevenue : 0}</h5>
                        <p>Total Revenue Earned</p>
                      </div>
                      <div></div>
                    </div>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <CurrencyRupeeIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{revenueEarnPhonepe?.totalPaidRevenue ? revenueEarnPhonepe?.totalPaidRevenue : 0}</h5>
                        <p>Received Payment</p>
                      </div>
                      <div></div>
                    </div>
                    <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                      <CurrencyRupeeIcon className='mt-3  fs-3' />
                      <div className='mt-3'>
                        <h5 className='fw-bold'>{revenueEarnPhonepe?.totalRefundRevenue ? revenueEarnPhonepe?.totalRefundRevenue : 0}</h5>
                        <p>Refund</p>
                      </div>
                      <div></div>
                    </div>
                    {
                      currentCountry == 'India' ?

                        <div className='col-sm-3 mt-2 dashboard-card d-flex justify-content-between'>
                          <PeopleAltIcon className='mt-3  fs-3' />
                          <div className='mt-3'>
                            <h5 className='fw-bold'>{provider ? provider : 0}</h5>
                            <p>Total Providers</p>
                          </div>
                          <div></div>
                        </div>
                        : null}
                  </>
                  : null}
              <div className="col-sm-12"></div>
              <div className="col-sm-6 mt-4 mb-5">
                <div className='d-flex justify-content-between'>
                  <h5 className='fw-bold'>
                    Growth
                  </h5>
                  <div className='d-flex'>
                    <select className='form-select' name="payment" value={filter.payment} onChange={handleChange}>
                      <option value="STRIPE">Stripe Payment</option>
                      <option value="RAZORPAY">Razorpay Payment</option>
                    </select>
                    <select className='form-select ms-2' name="day" value={filter.day} onChange={handleChange}>
                      <option value="DAILY">Daily</option>
                      <option value="MONTHLY">Monthly</option>
                      <option value="YEARLY">Yearly</option>
                    </select>
                  </div>
                </div>
                <div className="bgmain p-3 mt-4" style={{ height: '400px' }}>


                  <ResponsiveContainer width="80%" aspect={1.5}>
                    <BarChart
                      width={800}
                      height={500}
                      data={chartData}
                      margin={{ top: 55, left: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="_id" style={{ fontSize: '13px' }} />
                      <YAxis style={{ fontSize: '13px' }} />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="Total_Revenue" fill="#E95060" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div className="col-sm-6 mt-4 mb-5">
                <div className='d-flex justify-content-between'>
                  <h5 className='fw-bold'>
                    Trail Conversion Rate
                  </h5>
                  {/* <Button variant="text" sx={{ color: 'black', fontSize: '12px', background: 'white' }} startIcon={<FilterListIcon />}>Filters</Button> */}
                  <div></div>
                </div>
                <div className='bgmain mt-4' style={{ width: '68.5%', height: '400px' }}>
                  <ResponsiveContainer width="100%" height="70%">
                    <PieChart width={400} height={400}>
                      <Pie data={conversionRateChartData} dataKey="value" cx="50%" cy="50%" innerRadius={70} outerRadius={90} fill="#82ca9d"
                        label={(entry) => `${(entry.percent * 100)}%`} />
                    </PieChart>
                  </ResponsiveContainer>
                  <div className='d-flex justify-content-between ms-5 me-5'>
                    <p>Converted to Paid Subscribers</p>
                    <p className='fw-bold'>{conversionRateChartData?.map((item) => item.name == 'user Free Plan' ? item.totalCount : null)}</p>
                  </div>
                  <hr className='ms-5 me-5 mt-1' />
                  <div className='d-flex justify-content-between ms-5 me-5'>
                    <p>Canceled subcription plan users</p>
                    <p className='fw-bold'>{conversionRateChartData?.map((item) => item.name == 'Use Free Plan And Left' ? item.totalCount : null)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default Dashboard;